<template>
  <button
    v-if="!hasDropdown"
    :disabled="disabled"
    type="button"
    class="btn btn-light"
    @click="$emit('click')"
  >
    <i :class="[' fa-star', selected ? 'fas text-warning' : 'far']"></i>
  </button>
  <button
    v-else
    type="button"
    :class="['btn btn-light dropdown-toggle', disabled ? 'disabled' : '']"
    data-toggle="dropdown"
    aria-haspopup="true"
    aria-expanded="false"
  >
    <i :class="[' fa-star', selected ? 'fas text-warning' : 'far']"></i>
  </button>
</template>

<script>
export default {
  name: 'v',
  emits: ['click'],
  props: {
    hasDropdown: {
      type: Boolean,
      default: false
    },
    selected: {
      type: Boolean,
      default: false
    },
    disabled: {
      type: Boolean,
      default: false
    }
  }
}
</script>
